import { useCallback, useState } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import './App.css';

import { Header } from './components/header/Header';
import Heart from './components/heart/Heart';
import Age from './components/age/Age';
import TapBpm from './components/tap/TapBpm';
import FAQComponent from './components/faq/Faq';

const DEFAULT_BPM = 72;

function App() {
  const [bpm, setBpm] = useState(DEFAULT_BPM);
  const [resetSignal, setResetSignal] = useState(0);

  const handleResetAll = useCallback(() => {
    setBpm(DEFAULT_BPM);
    setResetSignal((s) => s + 1);
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <div className="app-shell">
        <div className="bg-aurora" />
        <Header />
        <section className="hero">
          <Heart bpm={bpm} />
          <button type="button" className="hero-reset" onClick={handleResetAll}>
            Reset all
          </button>
        </section>
        <TapBpm onBpmChange={setBpm} resetSignal={resetSignal} />
        <Age onBpmChange={setBpm} resetSignal={resetSignal} />
        <FAQComponent />
        <footer className="site-footer">
          <span>♥ Heart Rate Calculator</span>
        </footer>
      </div>
    </ChakraProvider>
  );
}

export default App;
